import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, forwardRef, Input, OnInit, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { NodeService } from './node.service';

@Component({
  selector: 'app-vs-tree',
  templateUrl: './vs-tree.component.html',
  styleUrls: ['./vs-tree.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VsTreeComponent),
      multi: true
    }
  ]
})
export class VsTreeComponent implements OnInit {

  @Input() treeConfig: any;

  private _model: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  files: TreeNode[];

  selectedFiles: TreeNode[] = [];

  loading: boolean;
  disabled: boolean;

  constructor(
    private http: HttpClient,
    private nodeService: NodeService,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) { }


  get model() {
    return this._model;
  }

  writeValue(value: any): void {
    this.setSelectedNodes(value);
    this._model = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setSelectedNodes(value: any) {
    this.checkNode(this.files, value);
  }

  nodeExpand(event) {
    if (event.node) {
      if (this.treeConfig.url) {
        this.loading = true;
        this.nodeService.getLazyFiles().then(nodes => {
          event.node.children = nodes
          this.loading = false;
        });
      }
    }
  }

  checkNode(nodes: TreeNode[], str: string[]) {
    for (let i = 0; i < nodes.length; i++) {
      if (!nodes[i].leaf && nodes[i].children[0].leaf) {
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (str.includes(nodes[i].children[j].data)) {
            if (!this.selectedFiles.includes(nodes[i].children[j])) {
              this.selectedFiles.push(nodes[i].children[j]);
            }
          }
        }
      }
      if (nodes[i].leaf) {
        return;
      }
      this.checkNode(nodes[i].children, str);
      let count = nodes[i].children.length;
      let c = 0;
      for (let j = 0; j < nodes[i].children.length; j++) {
        if (this.selectedFiles.includes(nodes[i].children[j])) {
          c++;
        }
        if (nodes[i].children[j].partialSelected) nodes[i].partialSelected = true;
      }
      if (c == 0) { }
      else if (c == count) {
        nodes[i].partialSelected = false;
        if (!this.selectedFiles.includes(nodes[i])) {
          this.selectedFiles.push(nodes[i]);
        }
      }
      else {
        nodes[i].partialSelected = true;
      }
    }
  }

  handleNodeSelection(event) {
    this.setSelectedToModel();
  }

  handleNodeUnSelection(event) {
    this.setSelectedToModel();
  }

  setSelectedToModel() {
    let data = [];
    this.selectedFiles.map(sf => {
      data.push(sf.data);
      return sf;
    });

    this._model = data;
    this.onChange(this._model);
  }

  getData() {
    this.loading = true;

    if (this.treeConfig.url) {
      this.http.get(this.treeConfig.url).subscribe((files: any) => {
        this.files = files.data
        this.loading = false;
      });
    } else if (this.treeConfig.data) {
      this.files = this.treeConfig.data;
      this.loading = false;
    }
  }

  ngOnInit() {
    this.getData();
  }

}
